import React from "react";

import Card from "react-bootstrap/Card";
// import Modal from 'react-bootstrap/Modal'

export default function ProjectCard({
  name,
  keywords,
  stack,
  course_name,
  start_date,
  end_date,
  description,
  project_url,
  source_url,
  video_url,
  extra,
}) {
  // const [demoConfig, setDemoConfig] = React.useState({
  //   show: false,
  //   demoVideo: ''
  // })

  // const handleClose = () => {
  //   setDemoConfig({show :false, demoVideo: ''})
  // }
  // const handleShow = (embed) => {
  //   setDemoConfig({show :true, demoVideo: embed})
  // }


  if (start_date != null) {
    let start_dateobj = new Date(start_date)
    start_date = String(start_dateobj.getFullYear()) + '.' + String(start_dateobj.getMonth() + 1)
  }
  if (end_date == null) {end_date = "Current"}
  else {
    let end_dateobj = new Date(end_date)
    end_date = String(end_dateobj.getFullYear()) + '.' + String(end_dateobj.getMonth() + 1)
  }

  let demo_link, source_link, video_link;
  if (project_url) {
    demo_link = <Card.Link href={project_url}  target="_blank">live demo</Card.Link>;
  }
  if (source_url) {
    source_link = <Card.Link href={source_url} target="_blank">source code</Card.Link>;
  }
  let stacks = stack.map((name) => { return (<li key={name}>{name}</li>)})
  let keywords_li = keywords.map((name) => { return (<li key={name}>{name}</li>)})
  
  let course;
  if (course_name) course ='- ' + course_name

  if (video_url) {
    video_link = <Card.Link variant="primary" href={video_url} target="_blank">
      video
</Card.Link> // onClick={() => handleShow(video_url)}
  }

  return (
    <>
      <Card className="card">
        <Card.Body>
          <Card.Title>{name}</Card.Title>
          <Card.Subtitle className="mb-2">
            {course}
          </Card.Subtitle>
          <Card.Subtitle className="mb-2 text-muted">
            {start_date} ~ {end_date}
          </Card.Subtitle>
          <Card.Text
            dangerouslySetInnerHTML={{ __html: description }}
          ></Card.Text>
          {demo_link}
          {source_link}
          {video_link}
          
        </Card.Body>
        <Card.Footer>
          <ul className='stacks'>
            {stacks}
            {keywords_li}
          </ul>
        </Card.Footer>
      </Card>
      {/* <p>{name}</p>
      <p>{stack}</p> */}
        {/* <>
            <Modal show={demoConfig.show} onHide={handleClose} className="videoPopup">
              <Modal.Header closeButton>
              </Modal.Header>
              <Modal.Body>
              <iframe height="100%" width="100%" src={demoConfig.demoVideo}
              frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowFullScreen>
                </iframe>
                </Modal.Body>
            </Modal>
          </> */}
      <style type="text/css">
        {`
        // .model-dialog {
        //   height: 800px; !important

        // }
     
      .stacks {
          list-style: none;
          text-indent: 0;
          margin:0;
          padding: 0;
      }

      .stacks > li {
        display: inline-block;
        background-color: #457b9d;
        color: white;
        font-size: small;
        margin: 2px;
        padding: 3px 10px;
        width: fit-content;
        border-radius: 15px;
      }
      
      `}
      </style>
    </>
  );
}
